'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function LongRight(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrows-long-right ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { d: 'M10 13.5l5.5-5.5-5.5-5.5v4.5h-9v2h9z' })
  );
}

LongRight.propTypes = _bcPropTypes.iconShape;
exports.default = LongRight;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Arrows/long/Right/Right.js
// module id = 135
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15